import Link from 'next/link'
import { useRouter } from 'next/router'
import { slugifyText } from '@/utils/helper'
import styles from './templates.module.css'

export interface CategoryProps {
  categories: string[]
  selectedCategory?: string
}

export function Category({
  categories,
  selectedCategory
}: CategoryProps): JSX.Element {
  const router = useRouter()
  const categoryPath = (category: string) =>
    `/templates/category/${encodeURIComponent(slugifyText(category))}`
  const selected = categories.includes(selectedCategory)
    ? categoryPath(selectedCategory)
    : '/templates'
  return (
    <aside className={styles.categories}>
      <nav aria-label="Template categories" className={styles.categoryNav}>
        <p className={styles.categoryLabel}>Browse by category</p>
        <Link
          href="/templates#template-list"
          aria-current={router.pathname === '/templates' ? 'page' : undefined}
        >
          All templates
        </Link>
        {categories.map(category => (
          <Link
            key={category}
            href={`${categoryPath(category)}#template-list`}
            aria-current={category === selectedCategory ? 'page' : undefined}
          >
            {category}
          </Link>
        ))}
      </nav>
      <div className={styles.categorySelect}>
        <label htmlFor="template-category">Browse by category</label>
        <select
          id="template-category"
          value={selected}
          onChange={event => router.push(`${event.target.value}#template-list`)}
        >
          <option value="/templates">All templates</option>
          {categories.map(category => (
            <option key={category} value={categoryPath(category)}>
              {category}
            </option>
          ))}
        </select>
      </div>
    </aside>
  )
}
